import { createApp } from 'vue'
import App from './App.vue'
import {createRouter, createWebHashHistory} from 'vue-router'
import * as bootstrap from 'bootstrap'
import "bootstrap/dist/css/bootstrap.min.css"

// 1. Define route components.
import HomePage from './components/HomePage'
import UpdateDatabase from './components/UpdateDatabase'
import MainDisplay from './components/MainDisplay'


// 2. Define routes
// Each route should map to a component.
const routes = [
    { path: '/hiddenindex', component: HomePage },
    { path: '/display', component: MainDisplay },
    { path: '/update6676', component: UpdateDatabase },
];

// 3. Create the router instance
const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

// 4. Global navigation guard to protect the /update6676 route
router.beforeEach((to, from, next) => {
    if (to.path === '/update6676') {
        const password = prompt("Enter password to access this page:");
        if (password === process.env.VUE_APP_API_CONTROL_PASS) {
            next(); // Allow access
        } else {
            alert("Incorrect password!");
            next(false); // Prevent navigation
        }
    } else {
        next(); // Allow other routes
    }
});

// 5. Create and mount the root instance.
const app = createApp(App);
app.use(router);
app.use(bootstrap);
app.mount('#app');